<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div class="modalBody">
        <div class="searchPatient">
          <form class="w-100" @submit.stop.prevent="getPatientsV2()">
            <div class="">
              <div class="SearchPti bolderTxt mt-3">
                <div><p>Buscar tutor (Ingrese el nombre completo):</p></div>
                <div>
                  <b-form-checkbox v-model="busquedaAvanzada" name="check-button" switch>
                    <b><p>Búsqueda avanzada</p></b>
                  </b-form-checkbox>
                </div>
              </div>
             <div class="SearchPti">
                <div class=" inputBusqueda">
                    <div v-if="busquedaAvanzada">
                      <b-row>
                        <b-col cols="col-sm-12 col-md-4 col-lg-4">
                          <b-form-input
                              :disabled="pacienteSeleccionado" 
                              v-model="nombre"
                              placeholder="Ingresa un nombre"
                              type="text"
                              v-on:keypress="esLetra($event)"
                              v-b-tooltip.hover
                              title="Búsqueda básica por nombre del paciente"
                              v-on:keyup.enter="getPatientsV2()"
                              class="input-buscador"
                            :state="nombre != null && nombre != ''"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="col-sm-12 col-md-4 col-lg-4">
                          <b-form-input
                            :disabled="pacienteSeleccionado" 
                              v-model="apellidoPaterno"
                              placeholder="Ingresa un apellido paterno"
                              type="text"
                              v-on:keypress="esLetra($event)"
                              v-b-tooltip.hover
                              title="Búsqueda básica por apellido paterno del paciente"
                              v-on:keyup.enter="getPatientsV2()"
                              class="input-buscador"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="col-sm-12 col-md-4 col-lg-4">
                          <b-form-input
                            :disabled="pacienteSeleccionado" 
                              v-model="apellidoMaterno"
                              placeholder="Ingresa un apellido materno"
                              type="text"
                              v-on:keypress="esLetra($event)"
                              v-b-tooltip.hover
                              title="Búsqueda básica por apellido materno del paciente"
                              v-on:keyup.enter="getPatientsV2()"
                              class="input-buscador"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                    </div>
                    <b-form-input v-else-if="nombreTutor != null"
                        disabled
                        v-model="nombreTutor"
                        placeholder="Ingresa el nombre completo del tutor"
                        type="text"
                        v-b-tooltip.hover
                        v-on:keyup.enter="getPatientsV2()"
                       :state="nombreTutor != null && nombreTutor != ''"
                    ></b-form-input>
                    <b-form-input v-else
                        :disabled="pacienteSeleccionado" 
                        v-model="nombreCompleto"
                        placeholder="Ingresa el nombre completo del tutor"
                        type="text"
                        v-b-tooltip.hover
                        v-on:keyup.enter="getPatientsV2()"
                        :state="nombreCompleto != null && nombreCompleto != ''"
                ></b-form-input>
                  </div>
                        <b-button v-if="!pacienteSeleccionado && nombreTutor == null" variant="primary" type="submit">
                    <b-icon icon="search"></b-icon>
                    </b-button>
                    <b-button v-else variant="outline-warning" @click="limpiarPacienteSeleccionado">
                        <b-icon icon="trash-fill"></b-icon>
                    </b-button>

             </div>
             <p style="font-size: .8em; font-weight: 600;">Si el tutor no existe en la base de datos, por favor agrégalo.</p>
            </div>
          </form>
        </div>
        <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="false"
        ></loading>
        <div class="mt-2" v-if="pacientesBuscados">
            <span>
                <p>Resultados de la Búsqueda</p>
                
                <div class="pl-5 pr-5">
                    <b-table
                  :items="patientTable"
                  :fields="encabezados"
                  :per-page="registrosPorPagina"
                  :current-page="paginaActual"
                  class="parrafos mb-3"
                  @row-clicked="setearPaciente"
                  responsive
                >
            
                  <template v-slot:cell(name)="row">
                      <div class="spanCien">
                        <span
                              v-b-tooltip.hover.top="'Es un paciente unificado.'"
                              v-if="row.item.estatusPacienteColorDTO != null && row.item.pacienteUnificado"
                              :style="'color:' + row.item.estatusPacienteColorDTO.color"
                          >
                          {{ row.item.name }}
                        </span>
                        <span
                            v-else-if="row.item.estatusPacienteColorDTO != null"
                            :style="'color:' + row.item.estatusPacienteColorDTO.color"
                        >
                          {{ row.item.name }}
                        </span>
                        <span v-else style="color: #000000">
                          {{ row.item.name }}
                        </span>
                      </div>
      
                  
                  </template>
                </b-table>
                <b-pagination
                    v-if="patientTable.length > 15"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="patientTable.length"
                    :per-page="registrosPorPagina"
                ></b-pagination>
                <div v-if="patientTable.length === 0" class="d-flex justify-content-center align-items-center">
                    <p style="font-size: .8em; color: rgb(189, 22, 22); font-weight: 600;">No se encontraron resultados.</p>
                </div>
                </div>
              </span>
        </div>
       
      </div>
    </div>
  </template>
  
  <script>
  //components
  import miniToastr from "mini-toastr"; //ES6
  
  export default {
    name: "BusquedaNombreTutores",
    props: {
      msg: String,
      nombreTutor:{
        type: String,
        default: null
      },
      headers: Object
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      patientTable: [],
      patients: [],
      busquedaAvanzada: false,
      pacienteSelect: null,
      patientInput: null,
      encabezados: [
        {key: "name", label: "Nombre del tutor", sortable: true},
        {key: "fechaNacimientoCompleta", label: "Fecha de nacimiento", sortable: true},
      ],
      registrosPorPagina: 5,
      paginaActual: 1,
      loading: false,
      nombreCompleto: "",
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      pacienteSeleccionado: false,
      pacientesBuscados: false,
    }),
    created() {
      this.debug = this.$localStorageService.getDebug();
      this.urlBase = this.$api;
    },
    methods: {
        setearPaciente(tutor){
            this.$emit('setearPaciente', tutor);
            this.pacienteSeleccionado = true;
            this.pacientesBuscados = false;
        },

        limpiarPacienteSeleccionado(){
            this.$emit('limpiarPacienteSeleccionado');
            this.nombreCompleto = "";
            this.nombre = "";
            this.apellidoPaterno = "";
            this.apellidoMaterno = "";
            this.pacienteSeleccionado = false;
            this.patientTable = [];
            this.pacientesBuscados = false;
            this.nombreTutor = null;
        },

      getPatientsV2() {
        this.loading = true;
         this.paginaActual = 1;
        if ((this.nombreCompleto != undefined && this.nombreCompleto.length >= 3) || (this.nombre != undefined && this.nombre.length >= 3) || (this.apellidoPaterno != undefined && this.apellidoPaterno.length >= 3) || (this.apellidoMaterno != undefined && this.apellidoMaterno.length >= 3)) {
          const inputTxt = this.nombreCompleto
              .trim()
              .toLowerCase()
              .toUpperCase();

          const params= {
            nombrePaciente: inputTxt
          }
          this.$http
              .post(
                  this.$api +
                  "paciente/perfiles/obtenerDatosPaciente",params , this.headers
                  
              )
              .then((response) => {
                if (response.status === 200) {
                  this.patientTable = [];
                  this.pacientesBuscados = true;
                  if (Array.isArray(response.data.data) == true) {
                    const uniqueAddresses = Array.from(
                        new Set(response.data.data.map((a) => a.id))
                    ).map((id) => {
                      return response.data.data.find((a) => a.id === id);
                    });
                    uniqueAddresses.map((elementDos) => {
                      var data = {
                        id: elementDos.id,
                        name: elementDos.nombre,
                        nacimiento: elementDos.fechaNacimiento,
                        fechaNacimientoCompleta: elementDos.fechaNacimientoCompleta,
                        colonia: elementDos.direccionTutor.colonia,
                        calle: elementDos.direccionTutor.calle,
                        cp: elementDos.direccionTutor.codigoPostal,
                        idPersona: elementDos.idPersona,
                        telefono: elementDos.telefono,
                        correo: elementDos.correo,
                        telefonoCasa: elementDos.telefonoCasa,
                        telefonoTrabajo: elementDos.telefonoTrabajo,
                        sobrenombre: elementDos.perfilPersona.sobrenombre,
                        facebook: elementDos.perfilPersona.facebook,
                        twitter: elementDos.perfilPersona.twitter
                      };
                      this.patientTable.push(data);
                      return data;
                    });
  
                    if (Array.isArray(this.patientTable) == true) {
                      this.patientTable.sort(function (a, b) {
                        if (a.id > b.id) {
                          return 1;
                        }
                        if (a.id < b.id) {
                          return -1;
                        }
                        return 0;
                      });
                    }
                  }
                }
              })
              .catch((error) => {
                miniToastr.info("No se encontraron pacientes");
                this.patientTable = [];
                console.error(error);
                this.loading = false;
                this.pacientesBuscados = false;
              })
              .finally(() => (this.loading = false));
        } else {
          this.loading = false;
        }
      },
      isLetter(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
  
        if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ/^\s+$/]+$/.test(char)) return true;
        // Match with regex
        else e.preventDefault(); // If not match, don't add to input text
      },
    },
  };
  </script>
  
  <style scoped>
  .template {
    width: 100%;
  }
  
  .colorHeader {
    background-color: #f6f6f6;
  }
  
  .headerTxt {
    font-weight: bold;
  }
  
  .SearchPti {
    width: 98%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  .inputBusqueda {
    width: 96%;
  }
  
  .swal2-title {
    font-size: 20px !important;
  }
  
  .mginTop {
    margin-top: 30px !important;
  }
  
  .searchPatient {
    width: 100%;
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
  }
  
  .BuscarTitle {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    font-size: 15px;
    font-weight: bolder;
    display: flex;
    padding-left: 25px;
    background-color: white !important;
    border-radius: 3px 0 0 0;
    border: 1px solid #ddd;
  }
  
  .searchicon {
    color: white !important;
    font-size: 16px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .bolderTxt {
    font-size: 14px;
    font-weight: bolder;
  }
  
  .spanCien {
    width: 100% !important;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  
  .inputFlex {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  
  .inputDiv {
    margin-top: 10px;
    width: 90%;
  }
  @media (max-width: 700px){
    .searchPatient {
      height: 40vw !important;
    }
    .input-buscador{
      margin: 1vw;
    }
  }
  
  .btn-info {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
    border-radius: 20px;
  }
  .icon-boton{
    -webkit-filter: brightness(0) invert(1);
    filter: brightness(0) invert(1);
    height: 20px;
    display: block;
    position: relative;
    left: 0.5px;
  }
  .botonCentrado{
    padding-bottom: 4px;
    padding-top: 1px;
    padding-left: 2px;
    padding-right: 4px;
  }
  p {
        color: #0046a2 !important;
  }
  </style>
